import { STATS, TRUST_WORKER, COMPANY } from "../lib/data";
import { Phone, Check } from "lucide-react";
import Reveal from "./Reveal";

const POINTS = [
  "Techniciens diplômés et assurés",
  "Matériel professionnel de dernière génération",
  "Tarifs transparents communiqués à l'avance",
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <div className="relative rounded-[1.75rem] overflow-hidden border border-slate-200 shadow-xl shadow-slate-200/60 aspect-[4/3]">
            <img src={TRUST_WORKER} alt="Les artisans du Bon Dépanneur" loading="lazy" decoding="async" className="h-full w-full object-cover" />
          </div>
        </Reveal>

        <div>
          <Reveal>
            <span className="overline">La confiance en chiffres</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-3 font-display font-extrabold text-ink text-3xl md:text-5xl leading-tight">
              Rapides. Fiables. Transparents.
            </h2>
          </Reveal>

          <Reveal delay={0.15}>
            <ul className="mt-6 space-y-3">
              {POINTS.map((p) => (
                <li key={p} className="flex items-center gap-3 text-ink-soft font-medium">
                  <span className="h-5 w-5 rounded-full bg-brand-green/15 flex items-center justify-center">
                    <Check className="h-3 w-3 text-brand-green" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </Reveal>

          <div className="mt-10 grid grid-cols-2 gap-5">
            {STATS.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.1}>
                <div className="card-soft p-6">
                  <div className="font-display font-extrabold text-3xl md:text-4xl gradient-text">
                    {s.value}
                  </div>
                  <p className="text-ink-soft text-sm mt-1.5">{s.label}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <a href={COMPANY.phoneHref} className="btn-primary mt-10">
              <Phone className="h-4 w-4" /> Intervention immédiate
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
